// utils/supportedLanguages.js
export const supportedLanguages = [
  { code: "en", name: "English", direction: "ltr" },
  { code: "my", name: "Burmese", direction: "ltr" },
  { code: "fr", name: "French", direction: "ltr" },
  { code: "kar", name: "Karen", direction: "ltr" },
  { code: "sw", name: "Swahili", direction: "ltr" },
];

export default supportedLanguages;
